import * as React from "react";
import AppBody from "../../components/AppBody";
import Header from "../../components/Header";
import Image from "../../components/Image";
import RouteTitle from "../../components/RouteTitle";
export default function ShoppingExperienceUnsupportedPage() {
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(AppBody, null,
            React.createElement("div", { className: "flex items-center justify-center py-10" },
                React.createElement(Image, { src: "/assets/images/unsupported-magnifier.svg", width: "148", height: "148", alt: "" })),
            React.createElement("div", { className: "px-6" },
                React.createElement(RouteTitle, { className: "font-bold" }, "Unfortunately, we do not yet offer any of those kinds of insurance.")))));
}
